import React from 'react';
import './index.css';
import ArticleEditPage from './pages/ArticleEditPage';
import AdminPage from './pages/AdminPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/*" element={<ArticleEditPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
